import { InjectionToken } from '@angular/core';
import { environment } from '@environments/environment';

/**
 * Structure of the protected resource configuration object.
 */
export interface ProtectedResources {
  apiWater: {
    endpoint: string;
    scopes: {
      read: string[];
      write: string[];
    };
  };
  // 🧩 You can add more APIs here later, like:
  // apiSoil: { endpoint: string; scopes: { read: string[]; write: string[] } }
}

/**
 * Injection token used to provide protected resource config throughout the app.
 */
export const PROTECTED_RESOURCES = new InjectionToken<ProtectedResources>(
  'Protected Resources'
);

export function getProtectedResources(): ProtectedResources {
  const env = environment.azureId;

  return {
    apiWater: {
      endpoint: env.apiUri,
      scopes: {
        read: [`api://${env.apiClientId}/Water.Read`],
        write: [`api://${env.apiClientId}/Water.ReadWrite`]
      }
    }
  };
}
